import { render, staticRenderFns } from "./barrage-add-or-update.vue?vue&type=template&id=6e8cb4d3"
import script from "./barrage-add-or-update.vue?vue&type=script&lang=js"
export * from "./barrage-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports